// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const QueryReport = lazy(
  () => import('pages/reports/reportsDirectory/queryReport')
);
const QueryReportRoute = (
  <Route path={routeName.queryReport}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.DOWNLOAD_QUERY_REPORT}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <QueryReport pageType="query" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default QueryReportRoute;
